import { motion } from "framer-motion";
import { MessageSquare, PenTool, HardHat, CheckCircle } from "lucide-react";

const steps = [
  { icon: MessageSquare, title: "استشارة", desc: "نستمع لمتطلباتكم ونقدم رؤيتنا المهنية" },
  { icon: PenTool, title: "تصميم", desc: "نعد تصاميم مفصلة تعكس ذوقكم الراقي" },
  { icon: HardHat, title: "تنفيذ", desc: "فريقنا المتخصص ينفذ المشروع بأعلى المعايير" },
  { icon: CheckCircle, title: "تسليم", desc: "نسلمكم مشروعاً يتجاوز توقعاتكم" },
];

const ProcessSection = () => {
  return (
    <section className="section-padding bg-marble-dark">
      <div className="container mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <div className="w-12 h-0.5 gold-gradient mx-auto mb-4" />
          <h2 className="text-3xl md:text-4xl font-bold text-secondary mb-4">آلية العمل</h2>
          <p className="text-muted-foreground max-w-lg mx-auto">
            نتبع منهجية واضحة لضمان نجاح كل مشروع
          </p>
        </motion.div>

        <div className="relative grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-8">
          {/* Connector line */}
          <div className="hidden md:block absolute top-16 right-[12.5%] left-[12.5%] h-0.5 bg-border" />

          {steps.map((step, i) => (
            <motion.div
              key={step.title}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.15 }}
              className="flex flex-col items-center text-center relative"
            >
              <div className="w-16 h-16 rounded-full gold-gradient flex items-center justify-center mb-4 z-10 gold-shadow">
                <step.icon className="w-7 h-7 text-primary-foreground" />
              </div>
              <span className="text-xs font-bold text-primary mb-2">0{i + 1}</span>
              <h3 className="text-lg font-bold text-secondary mb-2">{step.title}</h3>
              <p className="text-muted-foreground text-sm leading-relaxed max-w-[200px]">{step.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProcessSection;
